import { useState, useEffect, useContext } from "react";
import axios from "axios";
import Preloader from "../../../shared/PreLoaders";
import { Authorization } from "../../../Context/Authorization";
import { AuthContext } from "../../../Context/AuthContext";

const inputStyle = {
  width: "100%", padding: "9px 12px", border: "1.5px solid #E2E8F0",
  borderRadius: 8, fontSize: 13, color: "#1A202C", background: "#fff",
  outline: "none", transition: "border-color 0.2s", cursor: "pointer",
};
const labelStyle = { fontSize: 12, fontWeight: 600, color: "#2D3748", marginBottom: 6, display: "block" };

const AddPayments = () => {
  const initialStage = {
    vfcId: "", accountId: "", voucherType: "", voucherNumber: "",
    partyDetails: "", amount: "", description: "", cashOrBank: "",
    date: "", type: "P", uploadDocument: "",
  };
  const [vfcOptions, setVfcOptions] = useState([]);
  const [accountOptions, setAccountOptions] = useState([]);
  const [voucherTypeOptions, setVoucherTypeOptions] = useState([]);
  const [formData, setFormData] = useState(initialStage);
  const [submitMessage, setSubmitMessage] = useState("");
  const [validationErrors, setValidationErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const Api = process.env.REACT_APP_API;
  const [previousTransactions, setPreviousTransactions] = useState([]);
  const { selectedJfmcType } = useContext(AuthContext);

  const fetchVfcs = async (jfmcTypeId) => {
    setLoading(true);
    try {
      const config = Authorization();
      const response = await axios.post(`${Api}/api/vfcs/names`, { jfmcTypeId }, config);
      setVfcOptions(response.data.vfcs);
    } catch (error) {
      console.log("Error fetching Data", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (selectedJfmcType) fetchVfcs(selectedJfmcType._id);
  }, [selectedJfmcType]);

  useEffect(() => {
    setLoading(true);
    const fetchAccounts = async () => {
      try {
        const Config = Authorization();
        const response = await fetch(`${Api}/api/accounts`, Config);
        const data = await response.json();
        setAccountOptions(data.data);
      } catch (error) {
        console.log("Error fetching Accounts", error);
      }
      setLoading(false);
    };
    fetchAccounts();
  }, [formData.vfcId]);

  useEffect(() => {
    const fetchPreviousTransactions = async () => {
      if (!formData.vfcId) return;
      try {
        const Config = Authorization();
        const response = await axios.post(`${Api}/api/transactions/previous`, { vfcId: formData.vfcId, limit: 10 }, { headers: { "Content-Type": "application/json", ...Config.headers } });
        if (Array.isArray(response.data.data)) {
          setPreviousTransactions(response.data.data.filter((t) => t.type === "P"));
        } else {
          setPreviousTransactions([]);
        }
      } catch (error) {
        console.error("Error fetching previous transactions:", error.response?.data || error);
      }
    };
    fetchPreviousTransactions();
  }, [formData.vfcId]);

  useEffect(() => {
    setLoading(true);
    const fetchVoucherTypes = async () => {
      try {
        const Config = Authorization();
        const response = await fetch(`${Api}/api/voucher-type-mappings`, Config);
        const data = await response.json();
        setVoucherTypeOptions(data.voucherTypeMappings);
      } catch (error) {
        console.log("Error fetching Voucher Types", error);
      }
      setLoading(false);
    };
    fetchVoucherTypes();
  }, []);

  const handleChange = async (e) => {
    const { name, type, value, files } = e.target;
    if (type === "file") {
      setFormData((prev) => ({ ...prev, [name]: files[0] }));
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.vfcId) errors.vfc = "VFC is required";
    if (!formData.accountId) errors.accountId = "Account is required";
    if (!formData.voucherType) errors.voucherType = "Voucher Head is required";
    if (!formData.voucherNumber) errors.voucherNumber = "Voucher Number is required";
    if (!formData.partyDetails) errors.partyDetails = "Name is required";
    if (!formData.amount) errors.amount = "Amount is required";
    if (!formData.cashOrBank) errors.cashOrBank = "Cash or Bank is required";
    if (!formData.date) errors.date = "Date is required";
    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = validateForm();
    if (Object.keys(errors).length > 0) { setValidationErrors(errors); return; }
    const formDataToSend = new FormData();
    formDataToSend.append("uploadDocument", formData.uploadDocument);
    for (const key in formData) {
      if (key !== "uploadDocument") formDataToSend.append(key, formData[key]);
    }
    try {
      const Config = Authorization();
      const response = await fetch(`${Api}/api/transactions`, { method: "POST", headers: { ...Config.headers }, body: formDataToSend });
      if (response.status === 201) {
        setFormData(initialStage);
        setValidationErrors({});
        setSubmitMessage("Payments submitted successfully!");
      } else {
        console.error("Error submitting form:", response.statusText);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const fieldFocus = (e) => (e.target.style.borderColor = "#4CAF50");
  const fieldBlur = (e) => (e.target.style.borderColor = "#E2E8F0");
  const errStyle = { fontSize: 11, color: "#C62828", marginTop: 3 };

  return (
    <div>
      {loading && <Preloader loading={loading} />}

      {/* ── Page Header ── */}
      <div style={{ marginBottom: 20 }}>
        <h4 style={{ margin: 0, fontWeight: 700, color: "#1A202C", fontSize: 18 }}>Add Payments</h4>
        <div style={{ fontSize: 12, color: "#718096", marginTop: 3 }}>
          <span style={{ color: "#A0AEC0" }}>Transactions</span>
          <span style={{ margin: "0 6px", color: "#CBD5E0" }}>›</span>
          <span style={{ color: "#2E7D32", fontWeight: 600 }}>Add Payments</span>
        </div>
      </div>

      {!selectedJfmcType ? (
        <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #FED7D7", padding: "48px 24px", textAlign: "center" }}>
          <div style={{ width: 60, height: 60, background: "#FFF5F5", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 14px" }}>
            <i className="mdi mdi-tag-outline" style={{ fontSize: 28, color: "#E53E3E" }} />
          </div>
          <div style={{ fontSize: 14, fontWeight: 700, color: "#2D3748", marginBottom: 6 }}>JFMC Type not selected</div>
          <div style={{ fontSize: 12, color: "#A0AEC0" }}>Use the <strong>JFMC Type</strong> selector in the top navigation bar</div>
        </div>
      ) : (
        <>
          {submitMessage && (
            <div style={{ marginBottom: 16, padding: "10px 16px", background: "#E8F5E9", border: "1px solid #C8E6C9", borderRadius: 8, fontSize: 13, color: "#1B5E20", display: "flex", alignItems: "center", gap: 8 }}>
              <i className="mdi mdi-check-circle-outline" /> {submitMessage}
            </div>
          )}

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20 }}>
            {/* ── Form Card ── */}
            <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #E2E8F0", boxShadow: "0 1px 4px rgba(0,0,0,0.06)", overflow: "hidden" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "12px 16px", background: "linear-gradient(135deg,#1B5E20,#2E7D32)" }}>
                <span style={{ width: 30, height: 30, background: "rgba(255,255,255,0.15)", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 15 }}>
                  <i className="mdi mdi-cash-usd" />
                </span>
                <span style={{ fontSize: 13, fontWeight: 700, color: "#fff" }}>New Payments Registration Form</span>
              </div>
              <div style={{ padding: "20px 24px" }}>
                <form onSubmit={handleSubmit} noValidate>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
                    <div>
                      <label style={labelStyle}>VFC</label>
                      <select name="vfcId" value={formData.vfcId} onChange={handleChange} style={inputStyle} onFocus={fieldFocus} onBlur={fieldBlur}>
                        <option value="">Select VFC</option>
                        {vfcOptions.map((vfc) => <option key={vfc._id} value={vfc._id}>{vfc.vfcName}</option>)}
                      </select>
                      {validationErrors.vfc && <div style={errStyle}>{validationErrors.vfc}</div>}
                    </div>
                    <div>
                      <label style={labelStyle}>Account</label>
                      <select name="accountId" value={formData.accountId} onChange={handleChange} style={inputStyle} onFocus={fieldFocus} onBlur={fieldBlur}>
                        <option value="">Select Account</option>
                        {accountOptions.map((acc) => <option key={acc._id} value={acc._id}>{acc.accountName}</option>)}
                      </select>
                      {validationErrors.accountId && <div style={errStyle}>{validationErrors.accountId}</div>}
                    </div>
                    <div>
                      <label style={labelStyle}>Voucher Head</label>
                      <select name="voucherType" value={formData.voucherType} onChange={handleChange} style={inputStyle} onFocus={fieldFocus} onBlur={fieldBlur}>
                        <option value="">Select Voucher Head</option>
                        {voucherTypeOptions.map((voucher) => <option key={voucher.voucherType._id} value={voucher.voucherType._id}>{voucher.voucherType.voucherName}</option>)}
                      </select>
                      {validationErrors.voucherType && <div style={errStyle}>{validationErrors.voucherType}</div>}
                    </div>
                    <div>
                      <label style={labelStyle}>Voucher Number</label>
                      <input type="text" name="voucherNumber" value={formData.voucherNumber} onChange={handleChange} style={inputStyle} onFocus={fieldFocus} onBlur={fieldBlur} />
                      {validationErrors.voucherNumber && <div style={errStyle}>{validationErrors.voucherNumber}</div>}
                    </div>
                    <div>
                      <label style={labelStyle}>Name</label>
                      <input type="text" name="partyDetails" value={formData.partyDetails} onChange={handleChange} style={inputStyle} onFocus={fieldFocus} onBlur={fieldBlur} />
                      {validationErrors.partyDetails && <div style={errStyle}>{validationErrors.partyDetails}</div>}
                    </div>
                    <div>
                      <label style={labelStyle}>Amount</label>
                      <input type="number" name="amount" value={formData.amount} onChange={handleChange} style={inputStyle} onFocus={fieldFocus} onBlur={fieldBlur} />
                      {validationErrors.amount && <div style={errStyle}>{validationErrors.amount}</div>}
                    </div>
                    <div>
                      <label style={labelStyle}>Description</label>
                      <input type="text" name="description" value={formData.description} onChange={handleChange} style={inputStyle} onFocus={fieldFocus} onBlur={fieldBlur} />
                    </div>
                    <div>
                      <label style={labelStyle}>Cash / Bank</label>
                      <select name="cashOrBank" value={formData.cashOrBank} onChange={handleChange} style={inputStyle} onFocus={fieldFocus} onBlur={fieldBlur}>
                        <option value="">Select</option>
                        <option value="cash">Cash</option>
                        <option value="bank">Bank</option>
                      </select>
                      {validationErrors.cashOrBank && <div style={errStyle}>{validationErrors.cashOrBank}</div>}
                    </div>
                    <div>
                      <label style={labelStyle}>Date</label>
                      <input type="date" name="date" value={formData.date} onChange={handleChange} style={inputStyle} onFocus={fieldFocus} onBlur={fieldBlur} />
                      {validationErrors.date && <div style={errStyle}>{validationErrors.date}</div>}
                    </div>
                    <div>
                      <label style={labelStyle}>Upload Document</label>
                      <input type="file" name="uploadDocument" onChange={(e) => setFormData({ ...formData, uploadDocument: e.target.files[0] })}
                        style={{ ...inputStyle, cursor: "default", padding: "7px 12px" }} />
                    </div>
                  </div>
                  <div style={{ marginTop: 20, display: "flex", gap: 10 }}>
                    <button type="submit"
                      style={{ display: "inline-flex", alignItems: "center", gap: 8, padding: "10px 24px", background: "linear-gradient(135deg,#1B5E20,#2E7D32)", color: "#fff", border: "none", borderRadius: 9, fontSize: 13, fontWeight: 700, cursor: "pointer", boxShadow: "0 3px 10px rgba(46,125,50,0.3)" }}>
                      <i className="mdi mdi-file-check" /> Submit
                    </button>
                    <button type="button" onClick={() => setFormData(initialStage)}
                      style={{ padding: "10px 20px", background: "#F7FAFC", color: "#718096", border: "1px solid #E2E8F0", borderRadius: 9, fontSize: 13, fontWeight: 600, cursor: "pointer" }}>
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>

            {/* ── Previous Transactions ── */}
            <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #E2E8F0", boxShadow: "0 1px 4px rgba(0,0,0,0.07)", overflow: "hidden" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "12px 16px", background: "linear-gradient(135deg,#1B5E20,#2E7D32)" }}>
                <span style={{ width: 30, height: 30, background: "rgba(255,255,255,0.15)", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 15 }}>
                  <i className="mdi mdi-history" />
                </span>
                <span style={{ fontSize: 13, fontWeight: 700, color: "#fff" }}>Previous Transactions</span>
              </div>
              <div style={{ overflowX: "auto" }}>
                <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
                  <thead>
                    <tr>
                      {["Date", "Voucher No", "Name", "Amount", "Description"].map((h) => (
                        <th key={h} style={{ padding: "10px 14px", textAlign: "left", fontWeight: 600, fontSize: 11, color: "#4A5568", borderBottom: "1px solid #EDF2F7", background: "#F7FAFC" }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {previousTransactions.length > 0 ? previousTransactions.map((txn, i) => (
                      <tr key={i} style={{ borderBottom: "1px solid #EDF2F7" }}>
                        <td style={{ padding: "9px 14px", color: "#718096" }}>{new Date(txn.date).toLocaleDateString()}</td>
                        <td style={{ padding: "9px 14px", color: "#4A5568" }}>{txn.voucherNumber}</td>
                        <td style={{ padding: "9px 14px", color: "#1A202C", fontWeight: 600 }}>{txn.partyDetails}</td>
                        <td style={{ padding: "9px 14px", color: "#4A5568" }}>{txn.amount}</td>
                        <td style={{ padding: "9px 14px", color: "#718096" }}>{txn.description}</td>
                      </tr>
                    )) : (
                      <tr><td colSpan={5} style={{ padding: "20px", textAlign: "center", color: "#A0AEC0", fontSize: 12 }}>No transactions found</td></tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AddPayments;
